import { Component, OnInit, Input, Output, EventEmitter, OnChanges, NgZone, ChangeDetectorRef } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { ResponseChangeModel } from 'src/app/incident/incident.component';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';


@Component({
  selector: 'app-inputType-dropdown',
  templateUrl: './inputType-dropdown.component.html',
  styleUrls: ['./inputType-dropdown.component.scss']
,  standalone: false
})
export class InputTypeDropdownComponent implements OnInit, OnChanges {

  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number; 
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Input() showName?: boolean=true; 
  @Input() IsReadOnly?:boolean=false;
  @Input() IsConsentScreen?:boolean=false;
  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];
  @Output() conditionalChange: EventEmitter<ResponseChangeModel> = new EventEmitter<ResponseChangeModel>();

  constructor(private cdr: ChangeDetectorRef, private zone: NgZone) {}
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['question'] && changes['question'].currentValue) {
      const currentQuestion = changes['question'].currentValue;
      this.question = { ...currentQuestion }; // Create a new reference to trigger change detection
      if (this.question.responseText && this.question.responseText.length > 0) {      
        this.question.options.forEach(option => {
          option["selected"] = option.value === this.question.responseText
        });       
      } else {        
        if (this.question.options) {
          this.question.options.forEach(option => option["selected"] = false);
        }       
      }
      this.CheckValidations(this.question.responseText);
      this.childQuestion.emit(this.question);
      this.cdr.markForCheck();      
    }
  }

  ngDoCheck()
  {
    if(this.question.errorMessage)
    {
    this.errormgvisible=false;
    this.validationerrormessage = [];
    this.CheckValidations(this.question["responseText"]);
    }
  } 
  ngOnInit() {  
    this.question["IsValid"] = true;
    this.validationerrormessage = [];
    this.errormgvisible = false;
  }
 
  onSelect(newValue, question, index) {
    //Make Selected to false
    question.options.forEach((e) => { e.selected = false; });
    this.errormgvisible=false;
    //Update Selected to true for newValue
    question.options.forEach((e) => {
      if (e.value == newValue) {
        e.selected = true;
      }
    });
    this.validationerrormessage = [];
    this.CheckValidations(newValue);
    //question.options[index-1].selected = true;   

  }

  onDropdownClick(event: MouseEvent, newValue: string) {
    // If user selects the first option with "Select" text at index 0, treat it as empty string
    const selectedIndex = (event.target as HTMLSelectElement).selectedIndex;
    if (selectedIndex === 0 && newValue === "Select") {
      newValue = "";
    }
    
    // If clicking the same value, do nothing
    if (newValue === this.question.responseText) {
      return;
    }

    // Prevent default radio button behavior to wait for parent's response
    event.preventDefault();
    event.stopPropagation();

    const updatedQuestion = { ...this.question };
    updatedQuestion.responseText = newValue;
    updatedQuestion.options = [...this.question.options];

    // First emit the check event and wait for parent's decision from pop up if any conditonal questions are there 
    this.conditionalChange.emit({
      question: updatedQuestion,
      oldResponse: this.question.responseText,
      newResponse: newValue,
      proceed: (shouldProceed: boolean) => {
        this.zone.run(() => {
          if (shouldProceed) {
            // Update both the model and view state
            this.question.responseText = newValue;
            // Update radio button states
            this.question.options = this.question.options.map(opt => ({
              ...opt,
              selected: opt.value === newValue
            }));

            // Run validations and emit changes with the NEW value
            this.validationerrormessage = []; 
            this.question.errorMessage = "";
            this.CheckValidations(newValue);
            this.childQuestion.emit(this.question);
            this.inputChange.emit(true); // Emit input change event only when value changes
          }
          else {
            // If the parent component cancels the change, revert the model state.
            // The UI was not updating because the object reference did not change.
            // By creating a new options array, we trigger change detection.
            const revertedOptions = this.question.options.map((opt, i) => {
             return { ...opt, selected: !(opt.value === newValue) };
            });
            this.question = { ...this.question, options: revertedOptions };
            let oldSelectedValue =  revertedOptions.filter(opt => opt.selected == true)[0];
            this.question.responseText = oldSelectedValue ? oldSelectedValue.value : "";
          }
          
          // Force the view to update in both cases
          this.cdr.markForCheck();
          this.cdr.detectChanges();
        });
      }
    });
    this.validationerrormessage = []; this.question.errorMessage = "";
    this.CheckValidations(this.question.responseText);
    this.childQuestion.emit(this.question);
  }

  CheckValidations(newValue: any) {
    const isEmpty = [null, ""].includes(newValue);
    this.question["responseText"] = isEmpty ? "" : newValue;
    this.question["IsValid"] = !(this.question.isQuestionRequired === "Y" && isEmpty);
    
    this.errormgvisible = !this.question["IsValid"];
     if(!this.question["IsValid"]){
     this.validationerrormessage.push("Input is mandatory");
   }
  }
}
